import { CardProps } from './types'

// export const getDefaultCards = (): CardProps[] => {
// 	return [
// 		{
// 			title: '50%',
// 			description: 'more contouring and conforming',
// 		},
// 		{
// 			title: '36',
// 			description: 'biometric sensors tracking your vitals',
// 		},
// 	]
// }

export const getDefaultCards = (): CardProps[] => {
	return [
		{
			title: '20%',
			description: 'thinner than Pod 3',
		},
		{
			title: '36',
			description: 'biometric sensors tracking your vitals',
		},
	]
}
